export default __webpack_public_path__ + "static/dilbahar-6f8ec5f4b695c35d72791aa7bcb82f12.png";